import customAxios from "../../customAxios";
import {APPROVE_DRIVER} from "../../routes";

const approveDriver = async (userId: string) => {
  try {
    return (
      await customAxios.put(APPROVE_DRIVER + `/${userId}`)
    ).data;
  } catch (error: unknown) {
    console.error({APPROVE_DRIVER: error});
    return false;
  }
};

export default approveDriver;
